<!--iOS打测试包-->
<template>
  <el-dialog title="iOS测试包" v-model="show" width="30%" :close-on-click-modal="false" @open="handleOpen"
    @close="handleClose">
    <el-form :model="formdata" ref="dialogForm" :rules="rules" status-icon label-width="auto">

      <el-form-item label="APP" prop="app_id">

        <el-select remote filterable v-model="formdata.app_id" :remote-method="querySearchApp">
          <el-option v-for="(item, index) in appList" :key="index" :value="item.appID" style="height: 50px"
            :label="item.name">
            <div style="display: flex;align-items: center;padding: 10px">
              <el-image class="app-logo" fit="contain" :src="item.logo ? item.logo.square : ''" />
              <span>{{ item.name }}</span>
              <span style="margin-left: 10px;color: #888888">{{ item.appID }}</span>
              <span style="margin-left: 10px;color: #999999">{{ item.app_ids }}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="分支" prop="branch">
        <el-autocomplete :fetch-suggestions="querySearchBranch" placeholder="请输入内容" v-model="formdata.branch" clearable>
        </el-autocomplete>
      </el-form-item>

      <el-form-item label="Profile" prop="profile">
        <el-select v-model="formdata.profile" clearable>
          <el-option v-for="(item, index) in profileOptions" :key="index" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="打包类型" prop="pack_type">
        <el-select placeholder="请输入内容" v-model="formdata.pack_type">
          <el-option v-for="(item, index) in packOptions" :key="index" :value="item.value" :label="item.name">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">
          打包
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { GetAppList, AppPack } from '@/request/api';

export default {
  name: "AppPackDialog",
  props: ['isShow'],
  data() {
    return {
      show: false,
      profileOptions: [
        { name: "随机", value: 0 },
        { name: "subo.test.1", value: 1 },
        { name: "subo.test.2", value: 2 },
        { name: "subo.test.3", value: 3 },
        { name: "subo.test.4", value: 4 },
        { name: "subo.test.5", value: 5 },
        { name: "subo.test.6", value: 6 },
        { name: "subo.test.7", value: 7 },
        { name: "com.subo.qingsongyike.hoc", value: 8 },
      ],
      branchOptions: [
        { name: "testing_0522", value: "testing_0522" },
        { name: "testing_2022", value: "testing_2022" },
        { name: "testing", value: "testing" },
        { name: "testing_alivc", value: "testing_alivc" },
        { name: "release", value: "release" },
        { name: "release_alivc", value: "release_alivc" },
      ],
      rules: {
        app_id: [{ required: true, message: "APP不能为空", trigger: "change" }],
        profile: [{ required: true, message: "Profile不能为空", trigger: "change" }],
        branch: [{ required: true, message: "分支不能为空", trigger: "change" }],
        pack_type: [{ required: true, message: "打包类型不能为空", trigger: "change" }],
      },
      appList: [],
      packOptions: [
        { name: "测试包", value: 1, },
        { name: "截图包", value: 2, }
      ],
      formdata: {
        app_id: "",//使用哪个App的配置信息
        profile: 0,//使用哪个profile打包
        branch: "",//分支
        pack_type: 1,//打包类型
      }
    };
  },
  mounted() {

  },
  methods: {
    /**
     * 搜索APP
     */
    querySearchApp(queryStr) {
      let params = {
        keyword: queryStr
      };
      GetAppList(params).then(data => {
        this.appList = data.list
      })
        .catch(() => {
          this.$message.error('查询失败')
        });
    },
    /**
    * 搜索分支
    */
    querySearchBranch(queryString, cb) {
      let branchOptions = this.branchOptions;
      let results = queryString ? branchOptions.filter(this.createFilter(queryString)) : branchOptions;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    /**
     * 打包操作
     */
    handleSubmit() {
      this.$refs['dialogForm'].validate(valid => {
        if (valid) {
          AppPack(this.formdata)
            .then(data => {
              this.$message.success("提交成功");
              this.handleClose();
              this.$emit("reloadTableData");
            })
            .catch(err => {
              this.$message.success("提交失败");
            });
        } else {
          return false;
        }
      });
    },
    /**
     * 处理关闭
     */
    handleClose() {
      this.formdata.app_id = "";
      this.formdata.branch = "";
      this.formdata.profile = "";
      this.show = false;
      this.$emit('close')
    },
    handleOpen() {
      this.$nextTick(() => {
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.clearValidate();
        }
      });
      this.querySearchApp()
    }
  },
  watch: {
    isShow(newValue) {
      this.show = newValue
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-footer button:first-child {
  margin-right: 10px;
}

.app-logo {
  width: 30px;
  height: 30px;
  object-fit: cover;
  margin-right: 10px
}
</style>
